/* eslint-disable import/prefer-default-export */
import { HttpErrorResponse } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Router } from "@angular/router";
import { forkJoin, Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { ContractUserService, UserService } from "../api-generated";
import IContractUserWithUserInfo from "../models/IContractUserWithUserInfo";
import LoadingService from "../services/loading.service";
import LocalContractUserService from "../services/local-contractUser.service";
import LocalUserService from "../services/local-user.service";
import { globalAdmin } from "../shared/staticValue";
import NavService from "../services/nav.service";

@Injectable({
  providedIn: "root",
})
export class UserListResolver {
  private contractUserService = inject(ContractUserService);
  localUserService = inject(LocalUserService);
  private userService = inject(UserService);
  localContractUserService = inject(LocalContractUserService);
  router = inject(Router);
  private navService = inject(NavService);
  private loadingService = inject(LoadingService);

  resolve(): Observable<IContractUserWithUserInfo[] | void> {
    this.loadingService.start();

    if (this.navService.getUser().Permissions.includes(globalAdmin)) {
      const localUsers = this.localUserService.getItems();
      return forkJoin([
        this.contractUserService.getAllContractUser(),
        localUsers && localUsers.length > 0
          ? Promise.resolve(localUsers)
          : this.userService.getAll("old"),
      ]).pipe(
        map(([contractUser, users]) => {
          if (!localUsers || localUsers.length === 0) {
            this.localUserService.setItems(users);
          }
          this.localContractUserService.setItems(contractUser);
          return contractUser.map((cu) => {
            const user = users.find((u) => {
              return u.id === cu.UserId;
            });
            return { ...cu, UserInfo: user };
          });
        }),
        catchError((error: HttpErrorResponse) => {
          console.log(error);
          // this.router.navigate(["error", error.status ? error.status : 500]);
          return of(null);
        }),
      );
    }
    this.router.navigateByUrl("/contracts");
    return of(null);
  }
}
